// extracted by mini-css-extract-plugin
export default {"wrapper":"ResultQuiz_wrapper__je9xo","playerVideo":"ResultQuiz_playerVideo__eKm-I","snow":"ResultQuiz_snow__-jH2e"};